import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { getFacturesByEleveId, reset } from '../factures/facture.reducer';
import { Card, Spin, Table, Tag } from 'antd';
import { TextFormat } from 'react-jhipster';
import { APP_DATE_FORMAT, AUTHORITIES } from 'app/config/constants';
import { hasAnyAuthority } from 'app/shared/auth/private-route';
import { Link, RouteComponentProps } from 'react-router-dom';
export const PaiementCard = ({ record }) => {
  const dispatch = useAppDispatch();

  const loading = useAppSelector(state => state.facture.loading);
  const facturesByEleve = useAppSelector(state => state.facture.facturesByEleve);
  const isSecretaire = useAppSelector(state => hasAnyAuthority(state.authentication.account.authorities, [AUTHORITIES.SECRETAIRE]));

  const moisListe = ['INSCRIPTION'];

  useEffect(() => {
    dispatch(reset());
    dispatch(
      getFacturesByEleveId({
        eleveId: record.eleveId,
        anneeScolaireId: record.anneeScolaireId,
      })
    );
  }, [record.eleveId, record.anneeScolaireId]);

  const sortedFacturesData = facturesByEleve
    ?.map(f => ({
      id: f.factureId,
      key: f.numeroFacture,
      statutFacture: f.statutFacture,
      dateEmission: f.dateEmission,
      datePaiement: f.datePaiement,
      montant: `${f.montant} CFA`,
      mois: f.scolarite || '',
    }))
    .reverse()
    ?.sort((a, b) => moisListe.indexOf(a.mois.split(' ')[0]) - moisListe.indexOf(b.mois.split(' ')[0]));

  const facturesColumns = [
    {
      title: 'Factures',
      dataIndex: 'mois',
      key: 'mois',
      render: (text, facture) =>
        !isSecretaire ? (
          <Link to={`/scolarite/${record.ecoleId}/${record.anneeScolaireId}/${facture.id}/details`}>
            <strong>{text}</strong>
          </Link>
        ) : (
          <strong style={{ color: '#888' }}>{text}</strong>
        ),
      align: 'center' as const,
    },
    {
      title: 'Date Emission',
      dataIndex: 'dateEmission',
      key: 'dateEmission',
      align: 'center' as const,
      render: date => <TextFormat type="date" value={date} format={APP_DATE_FORMAT} />,
    },
    {
      title: 'Montant',
      dataIndex: 'montant',
      key: 'montant',
      align: 'center' as const,
    },
    {
      title: 'Date Paiement',
      dataIndex: 'datePaiement',
      key: 'datePaiement',
      align: 'center' as const,
      render: date => (date ? <TextFormat type="date" value={date} format={APP_DATE_FORMAT} /> : null),
    },
    {
      title: 'Statut',
      dataIndex: 'statutFacture',
      key: 'statutFacture',
      align: 'center' as const,
      render(statut) {
        switch (statut) {
          case 'EN_ATTENTE':
            return <Tag color="red">En attente</Tag>;
          case 'EMISE':
            return <Tag color="blue">Envoyée</Tag>;
          case 'PAYEE':
            return <Tag color="green">Payée</Tag>;
          case 'CREE':
            return <Tag color="#999">Crée</Tag>;
          default:
            return <Tag color="#999">{statut}</Tag>;
        }
      },
    },
  ];

  return (
    <Card title={`Paiements - ${record.anneeScolaireName || 'Année scolaire'}`} style={{ marginTop: 10 }}>
      <Spin spinning={loading} tip="Chargement...">
        {sortedFacturesData?.length > 0 ? (
          <Table columns={facturesColumns} dataSource={sortedFacturesData} bordered pagination={false} />
        ) : (
          <div style={{ textAlign: 'center', padding: '20px' }}>Aucun historique de paiement trouvé</div>
        )}
      </Spin>
    </Card>
  );
};
